<template>
  <div class="xc-input-box">
    <div class="xc-label">
      <span>{{title}}</span>
    </div>
    <div class="xc-input">
      <input v-on:keyup.enter="handleSubmit" type="number" v-model="min"  min="0" placeholder="最小值">
    </div>
    <div class="xc-divider">
      <span></span>
    </div>
    <div class="xc-input">
      <input v-on:keyup.enter="handleSubmit" type="number" v-model="max"  min="0" placeholder="最大值">
    </div>
    <div class="xc-units">
      <span>{{unit}}</span>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return {
            min:null,
            max:null,
            screenWidth:null
        }
    },
    props:{
        title:{
            type:String,
            default:'提示文案'
        },
        unit:{
          type:String,
          default:'元'
        }
    },
    mounted(){
        this.handleMInWidth()
        window.onresize = () => {
            return (() => {
                this.handleMInWidth();
            })()
        }
    },
    methods:{
        handleSubmit(){
            this.$emit('select-enter')
        },
        handleMInWidth(){
            const xcInputList = document.querySelectorAll('.xc-input');
            const xcUnitsList = document.querySelectorAll('.xc-units');
            const xcLabelList = document.querySelectorAll('.xc-label');

            window.screenWidth = document.body.clientWidth
            this.screenWidth = window.screenWidth;
            if(this.screenWidth>1860){
                for(let j=0;j<xcUnitsList.length;j++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-units')[j].style.cssText = `width:${11}%`;
                    })
                }
                for(let i =0;i<xcInputList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-input')[i].style.cssText = `width:${28}%`;
                    })
                }
                for(let i =0;i<xcLabelList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-label')[i].style.cssText = `width:${26}%`;
                    })
                }
            }
            if(this.screenWidth>1440 && this.screenWidth<1860){
                for(let j=0;j<xcUnitsList.length;j++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-units')[j].style.cssText = `width:${10}%`;
                    })
                }
                for(let i =0;i<xcInputList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-input')[i].style.cssText = `width:${28}%`;
                    })
                }
                for(let i =0;i<xcLabelList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-label')[i].style.cssText = `width:${26}%`;
                    })
                }
            }
            if(this.screenWidth>1358 && this.screenWidth<=1440){
                for(let j=0;j<xcUnitsList.length;j++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-units')[j].style.cssText = `width:${13}%`;
                    })
                }
                for(let i =0;i<xcInputList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-input')[i].style.cssText = `width:${26}%`;
                    })
                }
                for(let i =0;i<xcLabelList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-label')[i].style.cssText = `width:${28}%`;
                    })
                }
            }
            if(this.screenWidth<=1358 && this.screenWidth>=1320){
                for(let j=0;j<xcUnitsList.length;j++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-units')[j].style.cssText = `width:${10}%`;
                    })
                }
                for(let i =0;i<xcInputList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-input')[i].style.cssText = `width:${26}%`;
                    })
                }
                for(let i =0;i<xcLabelList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-label')[i].style.cssText = `width:${31}%`;
                    })
                }
            }
            if(this.screenWidth<1320){
                for(let i =0;i<xcLabelList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-label')[i].style.cssText = `width:${31}%`;
                    })
                }
                for(let i =0;i<xcInputList.length;i++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-input')[i].style.cssText = `width:${26}%`;
                    })
                }
                for(let j=0;j<xcUnitsList.length;j++){
                    this.$nextTick(()=>{
                        document.getElementsByClassName('xc-units')[j].style.cssText = `width:${10}%`;
                    })
                }
            }
        }
    },
    watch:{
        min(value){
            this.$emit('eventFormPrice',{'min':this.min,'max':this.max})
        },
        max(value){
             this.$emit('eventFormPrice',{'min':this.min,'max':this.max})
        }
    }
};
</script>
<style lang="less" scoped>

.xc-input-box {
  padding-right: 8px;
  margin-bottom: 8px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  .xc-label {
    min-width: 26%;
    padding: 0 5px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid rgba(215, 221, 228, 1);
    border-right: 0;
    float: left;
    span {
      font-size: 14px;
      color: #464c5b;
    }
  }
  .xc-input {
    width: 28%;
    height: 32px;
    line-height: 32px;
    float: left;
    border: 1px solid rgba(215, 221, 228, 1);
    input {
      width: 100%;
      height: 24px;
      line-height: 24px;
      padding: 4px 7px;
      outline: none;
      background: rgba(255, 255, 255, 1);
      border: 0;
      color:#464C5B;
      &::placeholder{
        color: #9EA7B4;
      }
    }
    input:focus {
      outline: none;
    }
  }
  .xc-input:hover{
    border-color: #57a3f3;
    transition:border 0.2s ease-in-out, background 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out
  }
  .xc-divider {
    width: 7%;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(215, 221, 228, 1);
    float: left;
    border-left: 0;
    border-right: 0;
    span {
      display: block;
      width: 8px;
      height: 1px;
      overflow: hidden;
      background: rgba(70, 76, 91, 1);
      margin-top: 15px;
      margin-left: 35%;
    }
  }
  .xc-units {
    width: 11%;
    height: 32px;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid rgba(215, 221, 228, 1);
    border-left:0; 
    float: left;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #464C5B;
  }
}
</style>
